// Guided tours for the demo site (synthetic data only). Each step opens a screen and points at one part of it.
// Text lives in i18n under "tour.<tourId>.<stepKey>" (title + body), English and Hindi.
import type { Role } from '../../types';

export interface TourStep {
  key: string;
  route: string;
  target?: string; // data-testid of the element to point at
}

export interface TourDef {
  id: 'doctor' | 'reception';
  role: Role;
  facilityId: string;
  steps: TourStep[];
}

export const TOURS: Record<TourDef['id'], TourDef> = {
  doctor: {
    id: 'doctor',
    role: 'doctor',
    facilityId: 'sharma-meerut',
    steps: [
      { key: 'welcome', route: '/', target: 'list-hero' },
      { key: 'attention', route: '/', target: 'list-urgent' },
      { key: 'awaiting', route: '/', target: 'awaiting-doctor-section' },
      { key: 'callSummary', route: '/calls/c-s2', target: 'call-summary' },
      { key: 'transcript', route: '/calls/c-s2', target: 'call-transcript' },
      { key: 'recording', route: '/calls/c-s2', target: 'call-recording-section' },
      { key: 'callMother', route: '/calls/c-s2', target: 'call-detail-call-mother' },
      { key: 'calls', route: '/calls', target: 'calls-tiles' },
      { key: 'review', route: '/calls', target: 'calls-tab-review' },
      { key: 'patient', route: '/patients/m-s2', target: 'patient-detail-page' },
      { key: 'about', route: '/patients/m-s2', target: 'detail-tab-details' },
      { key: 'vitals', route: '/patients/m-s2/visits/new', target: 'vitals-section' },
      { key: 'diagnosis', route: '/patients/m-s2/visits/new', target: 'diagnosis-section' },
      { key: 'prescription', route: '/patients/m-s2/visits/new', target: 'add-prescription-button' },
      { key: 'templates', route: '/prescriptions', target: 'templates-page' },
      { key: 'script', route: '/scripts', target: 'script-text' },
      { key: 'impact', route: '/reports', target: 'impact-panel' },
      { key: 'settings', route: '/settings', target: 'settings-ready' },
      { key: 'done', route: '/' },
    ],
  },
  reception: {
    id: 'reception',
    role: 'staff',
    facilityId: 'sharma-meerut',
    steps: [
      { key: 'welcome', route: '/', target: 'list-hero' },
      { key: 'attention', route: '/', target: 'list-urgent' },
      { key: 'add', route: '/patients/new', target: 'quick-add-page' },
      { key: 'attendance', route: '/attendance', target: 'attendance-list' },
      { key: 'calls', route: '/calls', target: 'calls-drifting' },
      { key: 'flags', route: '/flags', target: 'flags-page' },
      { key: 'patient', route: '/patients/m-s2', target: 'patient-detail-page' },
      { key: 'about', route: '/patients/m-s2', target: 'patient-call-button' },
      { key: 'done', route: '/' },
    ],
  },
};
